<form [formGroup]="formGroup">
	<div class="form-check form-switch">
		<input class="form-check-input" [formControlName]="name" type="checkbox" role="switch" [id]="randomId" />
		<ng-container *ngIf="label">
			<label class="form-check-label text-muted" [for]="randomId">{{ label }}</label>
		</ng-container>
	</div>
</form>
